/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { DataTable, DataTableRowToggleEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import CalendarDateSelector from "../CalendarDateSelector";
import { convertUTCEpochToDate } from "../../../../helper/DateConverters";
import { tableHeaderTemplate } from "../../Work Time Log Management/common/TimeLogTemplates";
import { fetchAllObserveInformReports } from "./fetchData";
import QRCodeModal from "./QRCodeModal";
import { Tooltip } from "primereact/tooltip";

const ObserveInformReportListing: React.FC = () => {
  const [expandedRows, setExpandedRows] = useState<any>([]);
  const [reports, setReports] = useState<any>([]);
  const [reportsLoading, setReportsLoading] = useState<boolean>(false);
  const [exportLoading, setExportLoading] = useState<boolean>(false);
  const [showQRModal, setShowQRModal] = useState<boolean>(false);

  const [filters, setFilters] = useState<any>({
    startDate: null,
    endDate: null,
  });
  const toast = useRef<Toast>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sortFilter, setSortFilter] = useState<any>({
    sortField: "formDate",
    sortOrder: true,
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (filters.startDate && filters.endDate) {
      fetchAllObserveInformReports(
        setReports,
        setReportsLoading,
        filters,
        toast,
      );
    }
  }, [filters?.startDate, filters.endDate]);

  console.log("reports", reports);

  useEffect(() => {
    if (reports.length > 0) {
      setExpandedRows([reports[0]]);
    }
  }, [reports]);

  const siteLocationBodyTemplate = (rowData: any) => {
    const siteLocation = rowData.formJson?.siteLocation || "N/A";
    const displayText =
      siteLocation.length > 100
        ? siteLocation.substring(0, 100) + "....."
        : siteLocation;

    return (
      <div
        className="show-truncated-site-location tw-flex tw-items-center tw-gap-2 hover:tw-bg-[#E8F9FF] tw-p-2 tw-cursor-pointer"
        data-pr-tooltip={siteLocation.length > 100 ? siteLocation : ""}
      >
        <Tooltip
          target=".show-truncated-site-location"
          position="top"
          className="tw-text-xs"
        />
        <div
          className="tw-text-gray-700 tw-text-sm tw-font-medium"
          data-pr-tooltip={siteLocation}
        >
          {displayText}
        </div>
      </div>
    );
  };

  const nameBodyTemplate = (rowData: any) => {
    return (
      <div className="tw-text-gray-700 tw-text-base tw-font-semibold tw-cursor-pointer">
        {rowData?.formJson?.name || "-"}
      </div>
    );
  };

  const projectNameBodyTemplate = (rowData: any) => {
    const projectName =
      rowData?.projectName || rowData?.formJson?.project?.name;
    // const getBadgeClass = () => {
    //   switch (projectName) {
    //     case "Safety":
    //       return "tw-bg-blue-100 tw-text-blue-800";
    //     case "Quality":
    //       return "tw-bg-purple-100 tw-text-purple-800";
    //     case "Environmental":
    //       return "tw-bg-yellow-100 tw-text-yellow-800";
    //     default:
    //       return "tw-bg-gray-100 tw-text-gray-800";
    //   }
    // };

    return (
      <span
        className={`tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-text-[#374151]`}
      >
        {projectName || "N/A"}
      </span>
    );
  };

  const observationBodyTemplate = (rowData: any) => {
    const observation =
      rowData?.observationType || rowData?.formJson?.observation?.name;
    // const badgeClass =
    //   observation === "Good"
    //     ? "tw-bg-green-100 tw-text-green-800"
    //     : "tw-bg-red-100 tw-text-red-800";

    return (
      <span
        className={`tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-text-[#374151]`}
      >
        {observation || "N/A"}
      </span>
    );
  };

  const departmentBodyTemplate = (rowData: any) => {
    return (
      <span className="tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-text-[#374151]">
        {rowData?.departmentName || "-"}
      </span>
    );
  };

  const createdOnBodyTemplate = (rowData: any) => {
    return (
      <div className="tw-text-gray-700 tw-text-sm tw-font-medium">
        <span>
          {new Date(rowData.createdDate).toLocaleTimeString("en-EN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })}
        </span>
      </div>
    );
  };

  const emptyMessageTemplate = (
    <div style={{ textAlign: "center", fontSize: "1.25rem" }}>
      <h4>No records found.</h4>
    </div>
  );

  return (
    <>
      <Toast ref={toast} />
      <QRCodeModal visible={showQRModal} onHide={() => setShowQRModal(false)} />
      <div className="tw-bg-[#F8FAFC] tw-border-solid tw-border tw-border-[#E2E8F0] tw-rounded-lg">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-4 tw-p-4 tw-gap-2 tw-flex-wrap">
          <h2 className="tw-text-xl tw-font-semibold">
            Observe. Inform. Report.
          </h2>
          <div className="tw-flex tw-gap-2 tw-items-center tw-justify-end tw-flex-wrap">
            <CalendarDateSelector setDateRange={setFilters} />
            {/* <Button
              className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-white tw-border tw-border-gray-300 tw-text-gray-700 tw-font-medium hover:tw-bg-gray-50"
              icon="pi pi-file-excel"
              loading={exportLoading}
              disabled={reports.length === 0 || exportLoading}
              onClick={() =>
              fetchAllObserveInformReports(
                setReports,
                setReportsLoading,
                filters,
                  toast,
                  "export",
                  )
                  }
                  /> */}

            <Button
              type="button"
              className="tw-flex tw-px-9 tw-py-2 tw-rounded bg-secondary border-primary hover:tw-bg-[#3f3c3c] tw-text-white tw-font-medium focus:tw-shadow-none"
              icon="pi pi-upload"
              label="Export"
              loading={exportLoading}
              disabled={reports.length === 0 || exportLoading}
              onClick={() =>
                fetchAllObserveInformReports(
                  setReports,
                  setReportsLoading,
                  filters,
                  toast,
                  "export",
                  setExportLoading,
                )
              }
            />
            <Button
              className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-white tw-border tw-border-gray-300 tw-text-gray-700 tw-font-medium hover:tw-bg-gray-50"
              label="View QR"
              icon="pi pi-qrcode"
              onClick={() => setShowQRModal(true)}
            />
            <Button
              className="tw-flex tw-px-3 tw-py-2 tw-rounded bg-primary border-primary tw-text-white tw-font-medium"
              label="Add"
              icon="pi pi-plus"
              onClick={() =>
                navigate("/layout/health-and-safety/add-observe-inform-report")
              }
            />
          </div>
        </div>
        {reportsLoading ? (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
            <ProgressSpinner />
          </div>
        ) : (
          <DataTable
            value={reports}
            emptyMessage={emptyMessageTemplate}
            rowGroupMode="subheader"
            groupRowsBy="formDate"
            expandableRowGroups
            expandedRows={expandedRows}
            onRowToggle={(e: DataTableRowToggleEvent) => {
              setExpandedRows(e.data);
            }}
            tableStyle={{ minWidth: "50rem" }}
            rowGroupHeaderTemplate={(data: any) => {
              return (
                <div className="tw-inline-flex tw-justify-between tw-items-center tw-gap-3 table-row-group-header tw-bg-[#F8FAFC] tw-pl-2 tw-text tw-font-semibold tw-text-base tw-text-[#64748B]">
                  {convertUTCEpochToDate(data.formDate)}
                </div>
              );
            }}
            onRowClick={(e) => {
              const rowData = e.data;
              navigate(
                `/layout/health-and-safety/view-observe-inform-report?formID=${rowData.formID}`,
              );
            }}
            rowClassName={() =>
              "hover:tw-bg-[#E8F9FF] tw-cursor-pointer tw-text-[#64748B]"
            }
            className="a-table timelog-datatable tw-text-nowrap tw-text-sm tw-text-[#64748B]"
            style={{ backgroundColor: "#000 !important" }}
          >
            <Column
              field="name"
              header={tableHeaderTemplate("Name", "", setSortFilter)}
              body={nameBodyTemplate}
            />
            <Column
              field="siteLocation"
              header={tableHeaderTemplate("Site Location", "", setSortFilter)}
              body={siteLocationBodyTemplate}
            />
            <Column
              field="projectName"
              header={tableHeaderTemplate("Project Name", "", setSortFilter)}
              body={projectNameBodyTemplate}
            />
            <Column
              field="observation"
              header={tableHeaderTemplate("Observation", "", setSortFilter)}
              body={observationBodyTemplate}
            />
            <Column
              field="departmentName"
              header={tableHeaderTemplate("Department", "", setSortFilter)}
              body={departmentBodyTemplate}
            />
            <Column
              field="createdOn"
              header={tableHeaderTemplate("Created On", "", setSortFilter)}
              body={createdOnBodyTemplate}
            />
          </DataTable>
        )}
      </div>
    </>
  );
};

export default ObserveInformReportListing;
